module.exports = __webpack_public_path__ + "img/product-program-yszc-icon1.0fd8329b.png";